import { connect } from "react-redux";

import {
  selectUserIsLoggedIn,
  selectUserIsLoading
} from "selector/authSelectors";
import AuthProtectedRoute from "components/Auth/ProtectedRoute";

export const mapStateToProps = (state, ownProps) => {
  return {
    loggedIn: selectUserIsLoggedIn(state),
    userIsLoading: selectUserIsLoading(state),
    loginPath: "/login",
    ...ownProps
  };
};

const ProtectedRouteContainer = connect(mapStateToProps)(AuthProtectedRoute);

export default ProtectedRouteContainer;
